import React from 'react';
import _ from 'lodash';
import NewUserHttpService from 'services/NewUserHttpService';
import Input from 'blocks/Input';
import validate from 'validate.js';
import {withRouter} from 'react-router-dom';
import Select from 'blocks/Select';
import {inject, observer } from 'mobx-react'
import { observe } from 'mobx'
import {Link} from 'react-router-dom';
import {IACP_LOGO} from 'constants/sponsor_logos';
import Checkbox from 'blocks/filters/Checkbox';
import classNames from 'classnames';


const EMAIL_CONFIRMATION = 'Email and email confirmation do not match';
const options = [
  { value: 'Addiction Counsellor', title: 'Addiction Counsellor' },
  { value: 'Counsellor', title: 'Counsellor' },
  { value: 'Psychotherapist', title: 'Psychotherapist' },
  { value: 'Psychologist', title: 'Psychologist' },
  { value: 'Psychiatrist', title: 'Psychiatrist' },
  { value: 'Supervisor', title: 'Supervisor' },
  { value: 'Student', title: 'Student' },
  { value: 'Healthcare Professional', title: 'Healthcare Professional' },
  { value: 'Life Coach', title: 'Life Coach' },
  { value: 'General Public', title: 'General Public' }
];
const OPTIONS_GOVERNING = [
  // { value: '4', title: 'ACI'},
  { value: '0', title: 'IACP' },
  { value: '1', title: 'IAHIP' },
  { value: '2', title: 'PSI' },
  { value: '3', title: 'Other' }
]


const VALIDATION_CONSTRAINTS = {
    email: {
      format: {
        pattern: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        message: 'is invalid'
      }
    },
  first_name:{
      length: {
        minimum: 1,
        maximum: 20,
        tooShort: 'is required',
        tooLong: 'maximum 20 symbols'
      }
  },
  last_name: {
    length: {
      minimum: 1,
      maximum: 20,
      tooShort: 'is required',
      tooLong: 'maximum 20 symbols'
    }
  },
  password: {
    length: {
      minimum: 6,
      tooShort: 'must be minimum 6 characters'
    }
  },
  membership_number: function(value, attributes, attributeName, options, constraints) {
    if (validate.contains(HAVE_NUMBER, attributes.governing_body)) {
      return {
        length: {
          minimum: 1,
          maximum: 10,
          tooShort: 'is required',
          tooLong: '^The max number of characters allowed is 10'
        }
      }
    }
    return;
  }
};

const HAVE_MEMBERSHIP = ['Counsellor', 'Psychotherapist', 'Psychologist'];
const HAVE_NUMBER = ['0', '1', '2'];


@withRouter
@inject('user')
@inject("SponsorStore")
@observer
class SignUp extends React.Component {

  state = {
    user: {
      first_name: '',
      last_name: '',
      email: '',
      email_confirmation: '',
      password: '',
      proffession_description: '',
      governing_body: '3',
      membership_number: ''
    },
    errors: {
    },
    tsAgree: false
  };

  constructor(props){
    super(props);
    this.newUserHttpService = new NewUserHttpService();
  }

  handleChangeAgree = () => {
    this.setState({
      tsAgree: !this.state.tsAgree
    })
  }

  handleChangeSignUpForm = data => {
    let newState = _.assign({}, this.state.user, data);
    this.setState({user: newState});
  };

  handleSubmitSignUpForm = event => {
    event.preventDefault();
    let errors = validate(this.state.user, VALIDATION_CONSTRAINTS);

    if(!this.state.user.email_confirmation) {
      errors =  _.assign(errors, {email_confirmation: ['Email confirmation is required'] })
    }

    if(this.state.user.email && this.state.user.email !== this.state.user.email_confirmation){
      errors =  _.assign(errors, {email_confirmation: [EMAIL_CONFIRMATION] });
    }

    if(!this.state.user.governing_body){
      errors =  _.assign(errors, {governing_body: ["Governing body is required"] });
    }

    if (errors) {
      this.setState({errors: errors});
      return
    }
    this.newUserHttpService.signUp({user: this.state.user})
      .then(res => this.handleSuccessSignUp(res))
      .catch(err => this.handleError());
  };

  handleSuccessSignUp = body => {
    this.props.user.setUser(body.data.user);
    localStorage.setItem('token', body.data.token);
    console.log(body.data.user.proffession_description, body.data.user.proffession_description !== 'General Public')
    if (body.data.user.proffession_description !== 'General Public')
      this.props.history.push('/myprofile/editprofile')
    else
      this.props.history.push('/public_webinars')
  };

  handleError = () => {
    this.setState({errors: {email: ['This email address has already been registered']}})
  };

  handleChangeProfessions = e => {
    let newState = _.assign({}, this.state.user, {proffession_description: e.target.value});
    this.setState({user: newState});
  };

  render(){

    const sponsorLogo = (
    // for future logic with diff sponsorId's
      <div className='row'>
        <div className="col">
          <div className='spons-logo-newuser'>
            <img src={IACP_LOGO} alt="spons"/>
          </div>
        </div>
      </div>
    )

    const governingBody = () => {
      if (HAVE_MEMBERSHIP.some(substring=>this.state.user.proffession_description.includes(substring))) {
        return (
        <div className="row">
          <div className="col">

            <Select
              elements={OPTIONS_GOVERNING}
              placeholder="Select your governing body"
              label="Select your governing body"
              name="governing_body"
              value={this.state.user.governing_body}
              handleChange={this.handleChangeSignUpForm}
              errors={this.state.errors.governing_body}
            />

          </div>
        </div>)
      }
    }

    const membershipNumber = () => {
      if (HAVE_NUMBER.some(substring=>this.state.user.governing_body.includes(substring))) {
        return (
          <div className="row">
            <div className="col">
              <Input name="membership_number"
                      type="text"
                      value={this.state.user.membership_number}
                      handleChange={this.handleChangeSignUpForm}
                      placeholder="Membership Number"
                      error={this.state.errors.membership_number}/>
            </div>
          </div>
        )
      }
    }


    return (
              <div className="row  align-items-center sign-up-form-holder">
                <div className="col-12 col-md-11">
                  <form onSubmit={this.handleSubmitSignUpForm}>
                    {this.props.SponsorStore.fromSponsor ? sponsorLogo : null }
                    <div className="row">
                      <div className="col">
                        <h1 className="sign-up-title">Create an Account. <span>It’s FREE!</span></h1>
                        <p className="sign-up-greeting">Please fill in all fields below:</p>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">

                        <Select
                          elements={options}
                          placeholder="Select Member Type"
                          label="Select Member Type"
                          name="proffession_description"
                          value={this.state.user.proffession_description}
                          handleChange={this.handleChangeSignUpForm}
                        />

                      </div>
                    </div>

                    {governingBody()}


                    {membershipNumber()}


                    <div className="row">
                      <div className="col-6">
                        <Input name="first_name"
                               type="text"
                               value={this.state.user.first_name}
                               handleChange={this.handleChangeSignUpForm}
                               placeholder="First Name"
                               error={this.state.errors.first_name}/>
                      </div>
                      <div className="col-6">
                          <Input name="last_name"
                                 type="text"
                                 value={this.state.user.last_name}
                                 handleChange={this.handleChangeSignUpForm}
                                 placeholder="Surname"
                                 error={this.state.errors.last_name}/>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <Input name="email"
                               type="email"
                               value={this.state.user.email}
                               handleChange={this.handleChangeSignUpForm}
                               placeholder="Email"
                               error={this.state.errors.email}/>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col">
                        <Input name="email_confirmation"
                               type="email"
                               value={this.state.user.email_confirmation}
                               handleChange={this.handleChangeSignUpForm}
                               placeholder="Email Confirmation"
                               error={this.state.errors.email_confirmation}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">

                        <Input name="password"
                               type="password"
                               value={this.state.user.password}
                               handleChange={this.handleChangeSignUpForm}
                               placeholder="Password"
                               error={this.state.errors.password}/>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="checkbox ts-agreement">
                          <input type="checkbox" id='tsagree' name='tsagree' checked={this.state.tsAgree} onChange={this.handleChangeAgree}/>
                          <label htmlFor="tsagree" />
                          <Link to='/termsofconditions'>I agree to the Terms of Service</Link>
                        </div>
                      </div>
                    </div>
                    <div className="btn-holder">
                      <button type="submit" className={classNames("btn empty bordered", {blue: this.state.tsAgree, disabled: !this.state.tsAgree})} disabled={!this.state.tsAgree}>sign up</button>
                    </div>
                    <div className="forgot-holder">
                      <Link to="/termsofconditions">
                        <span className="forgot">
                          By clicking "Sign Up" button YOU AGREE TO THE TERMS OF SERVICE
                        </span>
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
    );
  }
}
export default withRouter(SignUp);



// WEBPACK FOOTER //
// ./src/components/new_user/SignUp.jsx